import { selectSurface } from 'shared/assets/styles';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  min-width: 6.4rem;
`;

export const Button = styled.button<{
  $placeholder: boolean;
  $hasError: boolean;
  $noBorders: boolean;
  $isSmall: boolean;
}>`
  ${selectSurface};
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme, $isSmall }) =>
    $isSmall
      ? `${theme.spacing(1)} ${theme.spacing(6.5)} ${theme.spacing(1)} ${theme.spacing(2)}`
      : `${theme.spacing(1.5)} ${theme.spacing(6)} ${theme.spacing(1.5)} ${theme.spacing(2)}`};
  min-width: 0;

  border-radius: ${({ theme, $isSmall }) =>
    $isSmall ? theme.spacing(2.5) : theme.spacing(2)};
  transition: border-color 200ms;

  ${({ $isSmall }) =>
    !$isSmall &&
    css`
      box-shadow: none;
    `};

  ${({ $noBorders }) =>
    $noBorders &&
    css`
      border: none;
    `};

  &:hover {
    border-color: ${({ theme }) => theme.palette.grey[300]};
  }

  ${({ $placeholder, theme }) =>
    $placeholder &&
    css`
      color: ${theme.palette.text.secondary};
    `};

  ${({ theme, $hasError }) =>
    $hasError &&
    css`
      border-color: ${theme.palette.error.main};
    `};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding: ${({ theme }) =>
        `${theme.spacing(2.5)} ${theme.spacing(6)} ${theme.spacing(2.5)} ${theme.spacing(3)}`};
    `};
`;

export const Label = styled.span`
  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ChevronContainer = styled.span`
  position: absolute;
  top: 50%;
  right: ${({ theme }) => theme.spacing(2)};

  transform: translateY(-50%) rotate(270deg);
  pointer-events: none;

  color: ${({ theme }) => theme.palette.grey[600]};
  font-size: 1.6rem;
  line-height: 62.5%;
`;

export const FlexRowContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;
